@if (!state.isMobile) {
  @if (isDesktopChatVisible() && chatPosition() === ElementPosition.Floating) {
    <dojo-draggable-pane
      [options]="draggablePaneOptions()"
      (rectChange)="onChatRectChange($event)"
      wrapperClass="draggable-chat-wrapper !z-[301]"
      contentClass="chat-component z-1 relative overflow-hidden rounded-2xl border border-neutral-200 bg-neutral-0"
    >
      <dojo-image
        slot="drag-handle"
        class="sensei-chat-icon mt-1 size-14 shrink-0 cursor-grab transition duration-300 ease-in-out"
        @appearDisappear
        [src]="'assets/images/topic-practice/sensei/neutral-sensei.svg'"
      />

      <dojo-chat-dialog
        @appearDisappear
        [class.is-desktop]="!state.isMobile"
        (closed)="setChatClosed()"
        [additionalToolbarButtons]="toolbarButtonsTemplate"
      >
      </dojo-chat-dialog>
    </dojo-draggable-pane>
  }

  <div class="flex h-full">
    <as-split
      [direction]="splitDirection()"
      [unit]="'pixel'"
      [gutterSize]="DRAG_TARGET"
      [useTransition]="true"
      [gutterDblClickDuration]="300"
      [disabled]="!isDesktopChatVisible() || chatPosition() === ElementPosition.Floating"
    >
      @if (chatPosition() === ElementPosition.Top || chatPosition() === ElementPosition.Left) {
        <as-split-area
          [size]="state.isMobile ? 0 : state.isTablet ? TABLET_LEFT_NAV_WIDTH_PX : INITIAL_LEFT_NAV_WIDTH_PX"
          [minSize]="MIN_LEFT_NAV_WIDTH_PX"
          [maxSize]="MAX_LEFT_NAV_WIDTH_PX"
          [visible]="isDesktopChatVisible() && chatPosition() !== ElementPosition.Floating"
          class="relative"
        >
          @if (isDesktopChatVisible() && chatPosition() !== ElementPosition.Floating) {
            <dojo-chat-dialog
              @slideInToLeft
              [class.is-desktop]="!state.isMobile"
              class="chat-component z-1 relative bg-white"
              (closed)="setChatClosed()"
              [ngClass]="'chat-position-' + chatPosition()"
              [additionalToolbarButtons]="toolbarButtonsTemplate"
            />
          }
        </as-split-area>
        <as-split-area [size]="sizeWildcard" class="!overflow-y-hidden">
          <div class="flex h-full flex-col justify-between">
            <ng-container *ngTemplateOutlet="content"></ng-container>
          </div>
        </as-split-area>
      } @else {
        <as-split-area [size]="sizeWildcard" class="!overflow-y-hidden">
          <div class="flex h-full flex-col justify-between">
            <ng-container *ngTemplateOutlet="content"></ng-container>
          </div>
        </as-split-area>
        <as-split-area
          [size]="
            chatPosition() === ElementPosition.Floating
              ? 0
              : state.isMobile
                ? 0
                : state.isTablet
                  ? TABLET_LEFT_NAV_WIDTH_PX
                  : INITIAL_LEFT_NAV_WIDTH_PX
          "
          [minSize]="chatPosition() === ElementPosition.Floating ? 0 : MIN_LEFT_NAV_WIDTH_PX"
          [maxSize]="chatPosition() === ElementPosition.Floating ? 0 : MAX_LEFT_NAV_WIDTH_PX"
          [visible]="isDesktopChatVisible() && chatPosition() !== ElementPosition.Floating"
          class="relative"
        >
          @if (isDesktopChatVisible() && chatPosition() !== ElementPosition.Floating) {
            <dojo-chat-dialog
              @slideInToLeft
              [class.is-desktop]="!state.isMobile"
              class="chat-component z-1 relative bg-white"
              (closed)="setChatClosed()"
              [ngClass]="'chat-position-' + chatPosition()"
              [additionalToolbarButtons]="toolbarButtonsTemplate"
            />
          }
        </as-split-area>
      }
    </as-split>
    @if (state.question && (!state.isQuestionMultipleChoice || state.isTestingFlagOn)) {
      <dojo-solution-sidebar
        @slideInToLeft
        [readonly]="
          state.attemptStatus === 'GRADED' ||
          (state.attemptStatus === 'FAILED' && state.gradingError?.error_code !== GradingErrorCode.RejectedImages)
        "
      />
    }
  </div>
} @else {
  <ng-container *ngTemplateOutlet="content"></ng-container>
}

<ng-template #content>
  @if (state.isMobile) {
    <ion-header [translucent]="true" class="mobile-header">
      <ion-toolbar class="!px-0">
        <div class="small:mx-auto flex items-center justify-between px-0">
          <div slot="start" class="flex h-[52px] w-[50px] items-center justify-center" (click)="endPractice()">
            <dojo-icon-button [icon]="'xmark'" [iconSize]="26" class="h-[34px] w-[34px]" />
          </div>
          <ion-title class="common-small-ion-title">
            @if (state.showAwardedMarksBlock) {
              <ng-container *ngTemplateOutlet="awardedMarksBlock"></ng-container>
            } @else {
              <ng-container *ngTemplateOutlet="difficultyBlock"></ng-container>
            }
          </ion-title>
          <div
            slot="end"
            class="flex h-[52px] w-[50px] items-center justify-center"
            (click)="openQuestionActionDialog()"
          >
            <dojo-icon-button [icon]="'ellipsis-vertical'" [iconSize]="22" class="h-[34px] w-[34px]" />
          </div>
        </div>
      </ion-toolbar>
    </ion-header>
  }

  <ion-content [fullscreen]="true" class="relative">
    @if (state.isQuestionMultipleChoice && (!activeChatContext() || state.isMobile)) {
      <ion-fab
        slot="fixed"
        vertical="bottom"
        horizontal="end"
        class="h-[112px] w-[112px]"
        [ngClass]="state.isMobile ? 'fab-with-curved-border bottom-[-76px] right-0' : ''"
      >
        <dojo-sensei-fab
          [senseiImageType]="state.senseiImageType"
          [showSuggestions]="state.showMcqChatSuggestions && !state.isMobile"
          (chatToggled)="handleClickedFab($event)"
        />
      </ion-fab>
    }

    <div class="flex min-h-full flex-col md:pb-0" [class.pb-9]="state.isQuestionMultipleChoice">
      @if (state.hasPreviousAttempts && state.isQuestionReady) {
        <div class="bg-amber-50 py-1.5">
          <div class="standard-container">
            <p class="mb-0 items-center justify-center px-3 text-center text-sm text-amber-700 md:flex">
              <dojo-icon [icon]="'triangle-exclamation'" class="mr-1 text-amber-600" [size]="14"></dojo-icon>
              {{ 'topic_practice.previous_attempts_banner' | transloco }}
            </p>
          </div>
        </div>
      }

      @if (state.isMultiQuestionActivity) {
        <div class="border-b border-neutral-200">
          <div class="standard-container py-2">
            <dojo-question-progress />
          </div>
        </div>
      }

      <div class="flex flex-1 flex-col">
        @if (state.isQuestionReady) {
          <div class="standard-container flex-1" @slideLeftToRight>
            <div
              class="bg-neutral-0 z-3 top-0 flex flex-col flex-wrap justify-between gap-4 border-neutral-200 pb-3 pt-3 after:absolute after:bottom-0 after:left-3 after:right-3 after:hidden after:border-b after:border-neutral-200 after:content-[''] empty:hidden md:sticky md:mb-3 md:min-h-[65px] md:flex-row md:items-center md:px-3 md:after:block"
            >
              @if (state.showAwardedMarksBlock) {
                @if (!state.isMobile) {
                  <ng-container *ngTemplateOutlet="awardedMarksBlock"></ng-container>
                }
              } @else {
                <div class="font-primary text-primary text-md">[Maximum mark: {{ state.totalMarks }}]</div>
              }
              @if (!state.isMobile) {
                <div class="ml-auto flex items-center">
                  <ng-container *ngTemplateOutlet="difficultyBlock"></ng-container>
                  <span class="ml-5 mr-3 text-neutral-200">|</span>
                  <div class="flex flex-row-reverse items-center">
                    <ion-button
                      fill="clear"
                      class="footer-panel-button size-m"
                      [matTooltip]="state.questionFlagged ? ('unflag' | transloco) : ('report' | transloco)"
                      dojoQuestionFlagFeedback
                    >
                      <dojo-icon
                        [icon]="'flag'"
                        [iconClass]="state.questionFlagged ? 'fill-current text-yellow-500' : ''"
                        [size]="18"
                      ></dojo-icon>
                    </ion-button>
                    @if (state.formulaBooklet) {
                      <ion-button
                        fill="clear"
                        class="footer-panel-button size-m"
                        [matTooltip]="'formula_booklet' | transloco"
                        [target]="'_blank'"
                        [href]="state.formulaBooklet"
                      >
                        <dojo-icon [icon]="'memo-circle-info'" [size]="19"></dojo-icon>
                      </ion-button>
                    }
                  </div>
                </div>
              }
            </div>

            <div>
              @if (state.shouldShowNewQuestionFormat) {
                <dojo-question-items-viewer
                  [markCalculationMethod]="state.markCalculationMethod"
                  [selfGradingAllowed]="state.selfGradingAllowed"
                  [openedGradingResultItemId]="openedGradingResultItemId()"
                  [attemptStatus]="state.attemptStatus"
                  [activeChatContext]="activeChatContext()"
                  [isGraded]="state.questionGradedOrFailed"
                  (toggleChatDialogWithStemCoordinates)="toggleChatDialog($event)"
                  [class.is-desktop-chat-visible]="isDesktopChatVisible() && !state.questionGradedOrFailed"
                  [class.graded-question]="state.questionGradedOrFailed"
                  class="question-items-viewer mb-3 block"
                />
              } @else {
                <dojo-question-items-viewer-old
                  [questionItems]="state.questionItems"
                  [selfGradingAllowed]="state.selfGradingAllowed"
                  [openedGradingResultItemId]="openedGradingResultItemId()"
                  [isDesktopChatVisible]="isDesktopChatVisible()"
                  [attemptStatus]="state.attemptStatus"
                  [activeChatContext]="activeChatContext()"
                  (toggleChatDialog)="toggleChatDialog($event)"
                />
              }
            </div>
          </div>
        } @else {
          @defer (on timer(0.5s)) {
            <dojo-loader class="flex h-full flex-1 items-center justify-center" />
          }
        }
      </div>
      @if (state.isMobile && state.question && (!state.isQuestionMultipleChoice || state.isTestingFlagOn)) {
        <dojo-solution-sidebar
          [readonly]="
            state.attemptStatus === 'GRADED' ||
            (state.attemptStatus === 'FAILED' && state.gradingError?.error_code !== GradingErrorCode.RejectedImages)
          "
          class="z-1 sticky bottom-0"
        />
      }
    </div>
  </ion-content>
</ng-template>

@if (state.isMobile) {
  <dojo-footer-panel>
    <div class="right item-center flex flex-row justify-end gap-2">
      @if (state.selfGradingAllowed) {
        <dojo-button class="small:w-auto block w-full" (click)="selfGradeQuestionAttempt()">
          {{ 'grading.save_results' | transloco }}
        </dojo-button>
      } @else {
        @if (state.isQuestionMultipleChoice) {
          <dojo-button
            class="small:w-auto mr-[96px] block w-full"
            [pending]="state.questionIsInSubmittedStatus || state.isFetchingMCQNextQuestionAttempt"
            [disabled]="state.disableMcqCheckAnswerButton"
            (click)="multipleChoiceQuestionGrading()"
          >
            {{ state.mcqButtonText | transloco }}
          </dojo-button>
        } @else if (
          state.attemptStatus === 'GRADED' || (state.questionIsInSubmittedStatus && state.isQuestionMultipleChoice)
        ) {
          <dojo-button
            class="mr-[96px] block w-full"
            [pending]="state.questionIsInSubmittedStatus"
            (click)="goToNextQuestion()"
          >
            {{ 'examdojo.question.next_question' | transloco }}
          </dojo-button>
        } @else {
          <div
            [matTooltip]="'examdojo.question.add_answers_tooltip' | transloco"
            [matTooltipDisabled]="!(state.attemptStatus === 'SUBMITTED' || !isReadyToGrade())"
            class="w-full"
          >
            <dojo-button
              [fill]="'solid'"
              class="w-full"
              (click)="submitForGrading()"
              [pending]="state.questionIsInSubmittedStatus"
              [disabled]="state.attemptStatus === 'SUBMITTED' || !isReadyToGrade()"
            >
              {{ 'examdojo.question.upload_answer_for_grading' | transloco }}
            </dojo-button>
          </div>
        }
      }
    </div>
  </dojo-footer-panel>
} @else {
  <dojo-footer-panel [limitWidthContainer]="false">
    <div left>
      <dojo-button fill="outline" (click)="endPractice()" [customColor]="'red'" class="w-full md:min-w-[178px]">
        {{ 'end_practice' | transloco }}
      </dojo-button>
    </div>
    <div class="right item-center flex flex-row justify-end gap-2">
      @if (state.selfGradingAllowed) {
        <dojo-button
          class="w-full md:min-w-[178px]"
          [pending]="state.questionIsInSubmittedStatus"
          [disabled]="state.attemptStatus === 'SUBMITTED'"
          (click)="selfGradeQuestionAttempt()"
        >
          {{ 'grading.save_results' | transloco }}
        </dojo-button>
      } @else {
        @if (state.isQuestionMultipleChoice) {
          <dojo-button
            class="lalal w-full md:min-w-[178px]"
            [pending]="state.questionIsInSubmittedStatus || state.isFetchingMCQNextQuestionAttempt"
            (click)="multipleChoiceQuestionGrading()"
            [disabled]="state.disableMcqCheckAnswerButton"
          >
            {{ state.mcqButtonText | transloco }}
          </dojo-button>
        } @else if (state.attemptStatus === 'GRADED') {
          <dojo-button class="w-full md:min-w-[178px]" (click)="goToNextQuestion()">
            {{ 'examdojo.question.next_question' | transloco }}
          </dojo-button>
        } @else {
          <div
            [matTooltip]="'examdojo.question.add_answers_tooltip' | transloco"
            [matTooltipDisabled]="!(state.attemptStatus === 'SUBMITTED' || !isReadyToGrade())"
          >
            <dojo-button
              [fill]="'solid'"
              class="w-full md:min-w-[178px]"
              [pending]="state.questionIsInSubmittedStatus"
              (click)="submitForGrading()"
              [pending]="state.attemptStatus === 'SUBMITTED'"
              [disabled]="!isReadyToGrade()"
            >
              {{ 'examdojo.question.upload_answer_for_grading' | transloco }}
            </dojo-button>
          </div>
        }
      }
    </div>
  </dojo-footer-panel>
}

<ng-template #difficultyBlock>
  <div class="flex items-center justify-center gap-4">
    @if (state.difficulty) {
      <dojo-difficulty [difficulty]="state.difficulty"></dojo-difficulty>
    }
    <dojo-calculator-indicator [calculatorAllowed]="state.question?.metadata?.calculator_allowed ?? false" />
  </div>
</ng-template>
<ng-template #awardedMarksBlock>
  @if (state.totalMarks !== null && state.awardedMarks !== null) {
    <dojo-question-grading-result-header [totalMarks]="state.totalMarks" [awardedMarks]="state.awardedMarks" />
  }
</ng-template>

<ng-template #toolbarButtonsTemplate>
  <dojo-icon-button (click)="setChatClosed()" [icon]="'xmark'" />
</ng-template>
